const routes = [

	// Notes: Set `meta.isPublic: true` for any pages not requiring authentication. This is used by `app.checkCurrentAuthTokenStillValid()` so validation is not checked on public pages.


	//-- Publicly accessible pages
	{ 
		path: '/', 
		name: "root", 
		component: () => import("/unauthenticated/index.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" } 
	},
	{ 
		path: '/login', 
		name: "login", 
		component: () => import("/public2/login.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Login", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" } 
	},
	{ 
		path: '/logout', 
		name: "logout", 
		component: () => import("/unauthenticated/logout.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Logout", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" } 
	},
	{ 
		path: '/forgot-password', 
		name: "forgot-password", 
		component: () => import("/public2/forgot-password.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Forgot Password", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" } 
	},
	{
		path: '/reset-password/:token',
		name: "reset-password",
		component: () => import("/public2/reset-password.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Reset Password", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" }
	},

	// The two ways a session ends that aren't the person's doing. Reached through
	// /helpers/session.js, never linked to.
	{
		path: '/session-expired',
		name: "session-expired",
		component: () => import("/public2/session-expired.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Session Expired", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" }
	},
	{
		path: '/access-removed',
		name: "access-removed",
		component: () => import("/public2/access-removed.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Account Problem", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password)" }
	},

	{
		path: '/not-found',
		name: "not-found",
		component: () => import("/unauthenticated/not-found.vue"),
		meta: { layout: "public", layoutByAuth: true, isPublic: true, module: "", parentRouteName: "", pageTitle: "Not Found" }
	},

	{ 
		path: '/delete-account', 
		name: "delete-account", 
		component: () => import("/unauthenticated/delete-account.vue"),
		meta: { layout: "public", isPublic: true, module: "", parentRouteName: "", pageTitle: "Request Account Deletion" } 
	},



	//TODO: Not used at the moment. Initial idea stage.
	{ 
		path: '/get-started', 
		name: "get-started-root", 
		component: () => import("/home/get-started.vue"),
		meta: { layout: "primary", isPublic: true, module: "", parentRouteName: "", pageTitle: "Get Started with Lotus", kbFile: "get-started", kbTitle: "Get Started" } 
	},



	//TODO: 9 July 2023 - These endpoints are working, but disabling for now while in private beta.
	//
	// //-- Create account
	// { 	// Primary alias for /create-account/start
	// 	path: '/create-account', 
	// 	name: "create-account-start-root", 
	// 	component: () => import("/unauthenticated/create-account/start.vue"),
	// 	meta: { layout: "primary-domain-consistent", isPublic: true, pageTitle: "Create Account", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password, Signup)" }
	// },
	// {
	// 	path: '/create-account/start',
	// 	name: "create-account-start",
	// 	component: () => import("/unauthenticated/create-account/start.vue"),
	// 	meta: { layout: "primary-domain-consistent", isPublic: true, pageTitle: "Create Account", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password, Signup)" } 
	// },
	// { 
	// 	path: '/create-account/verify', 
	// 	name: "create-account-verify", 
	// 	component: () => import("/unauthenticated/create-account/verify.vue"),
	// 	meta: { layout: "primary-domain-consistent", isPublic: true, pageTitle: "Create Account - Verify Your Email", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password, Signup)" } 
	// },
	// { 
	// 	path: '/create-account/complete', 
	// 	name: "create-account-complete", 
	// 	component: () => import("/unauthenticated/create-account/complete.vue"),
	// 	meta: { layout: "primary-domain-consistent", isPublic: true, pageTitle: "Create Account - Complete!", kbFile: "public", kbTitle: "Public (Home, Login, Forgot Password, Signup)" } 
	// },




	//---- Go. Allow list redirector for the mobile app and other applications.
	{ 
		path: '/go/:id', 
		name: "Go",
		component: () => import("/go/index.vue"),
		meta: { layout: "no", isPublic: true, module: "", parentRouteName: "", pageTitle: "", kbFile: "", kbTitle: "" } 
	},

]


export default routes;